import * as React from "react";
import styled from "styled-components";
import * as sanitizeHtml from "sanitize-html";
import { graphql, useStaticQuery } from "gatsby";

const NieuwsContainer = styled.div`
  width: 100vw;
  padding-top: 100px;
  padding-bottom: 200px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;
const NieuwsFrame = styled.div`
  width: 60vw;
  display: flex;
  justify-content: center;
  a {
    text-decoration: none;
  }
`;
const Links = ({ data }) => {
  const queryLinks = useStaticQuery(graphql`
    query allStrapiLink {
      allStrapiLink {
        nodes {
          content {
            data {
              content
            }
          }
          subTitel
        }
      }
    }
  `);
  const content = queryLinks.allStrapiLink.nodes[0];

  const createMarkup = () => {
    var clean = sanitizeHtml(content.content.data.content, {
      allowedTags: sanitizeHtml.defaults.allowedTags.concat(["img"]),
      allowedAttributes: { img: ["src"], a: ["href", "target", "rel"] },
      allowedSchemes: ["data", "http", "https"],
    });
    return { __html: clean };
  };
  return (
    <>
      <NieuwsContainer>
        <NieuwsFrame>
          <div
            dangerouslySetInnerHTML={createMarkup()}
            className="ckContent"
          ></div>
        </NieuwsFrame>
      </NieuwsContainer>
    </>
  );
};

export default Links;
